var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#2D8CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.984 11.506v6.74c.006 1.524 1.361 2.75 3.014 2.745h10.693c.303 0 .55-.225.55-.498v-6.74c-.009-1.523-1.364-2.75-3.015-2.744H6.531c-.302 0-.547.224-.547.497zm14.936 2.63l4.416-2.963c.383-.292.68-.219.68.309v9.036c0 .601-.363.528-.68.309L20.92 17.87v-3.734z",
    fill: "#fff"
  })));
}

export default SvgZoom;